import React, { useEffect, useState } from "react";

import { ProgressSpinner } from "primereact/progressspinner";
import { TabMenu } from "primereact/tabmenu";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import { useHasPermissions } from "hooks/useHasPermissions";
import useProjectContext from "../../hooks/useProjectContext";
import ErrorPage from "../../routes/ErrorPage";
import ProjectDropDown from "../ProjectDropDown";

const MaintenanceLayout = () => {
  const path = useLocation().pathname;
  const { objectId, deviceId, maintenanceId } = useParams();
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    projectId,
    user,
    userSettings,
    project,
    projectLoading,
    userSettingsLoading,
    userSettingsError,
    projectError,
  } = useProjectContext();

  const isPermitted = useHasPermissions("USE_DATA_SERVICES");

  useEffect(() => {
    switch (path) {
      case `/mdm/project/${projectId}/maintenance`:
        return setActiveIndex(0);
      case `/mdm/project/${projectId}/settings`:
        return setActiveIndex(1);
      case `/mdm/project/${projectId}/objects/${objectId}`:
      case `/mdm/project/${projectId}/map/${objectId}`:
        return setActiveIndex(2);
      case `/mdm/project/${projectId}/devices/${deviceId}`:
        return setActiveIndex(3);
      case `/mdm/project/${projectId}/maintenance/${maintenanceId}`:
        return setActiveIndex(4);
      default:
        return setActiveIndex(10);
    }
  }, [path, projectId, objectId, deviceId, maintenanceId]);

  const items = [
    {
      label: T("mdm.maintenance"),
      icon: "pi pi-building",
      url: `#/mdm/project/${projectId}/maintenance`,
    },
    {
      label: T("word.settings"),
      icon: "pi pi-cog",
      url: `#/mdm/project/${projectId}/settings`,
    },
    {
      label: T("word.object"),
      icon: "pi pi-book",
      url: `#/mdm/project/${projectId}/objects/${objectId}`,
      visible: !!objectId,
    },
    {
      label: T("word.device"),
      icon: "pi pi-book",
      url: `#/mdm/project/${projectId}/devices/${deviceId}`,
      visible: !!deviceId,
    },
    {
      label: T("mdm.maintenance"),
      icon: "pi pi-building",
      url: `#/mdm/project/${projectId}/maintenance/${maintenanceId}`,
      visible: !!maintenanceId,
    },
  ];

  if (!isPermitted) return <div>{T("message.missing-required-permissions")}</div>;

  return (
    <div className="bg-white p-0 sm:p-3 mdm-container">
      <div className="flex gap-1 flex-column-reverse md:flex-row">
        {projectId && (
          <TabMenu
            model={items}
            className="flex-1 justify-content-end"
            activeIndex={activeIndex}
            onTabChange={e => setActiveIndex(e.index)}
          />
        )}
        {user?.companyRef && <ProjectDropDown />}
      </div>
      {userSettings && project && <Outlet />}
      {(projectLoading || userSettingsLoading) && <ProgressSpinner className="w-full" />}
      {(userSettingsError || projectError) && (
        <ErrorPage msg={userSettingsError?.message ?? projectError?.message ?? ""} />
      )}
    </div>
  );
};

export default MaintenanceLayout;
